import { Grid, withStyles } from '@material-ui/core';

import { smallRadius } from '~/src/dash/utils/material-dashboard-react';

export const ModelPrimaryContainerV2 = withStyles({
  root: {
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #eef0f4',
    borderRadius: smallRadius,
    opacity: '1',
    paddingLeft: '2%',
    paddingRight: '2%',
    minHeight: '50px',
    paddingTop: '10px',
    paddingBottom: 18,
  },
})(Grid);
